export default "__VITE_ASSET__Ce$_ukU1__"